export const environment = {
  googleMapsApiKey: 'AIzaSyAXM9-6Rzb9pfqCCgY0dabs6XCuZcH9Sik',
};
